<script>
import { deepFind } from '@isyscore/utils/deep';

export default {
    name: 'TheAsideMenu',
    props: {
        menuList: {
            type: Array,
            // {id, title}
            default: () => []
        }
    },
    watch: {
        '$route.query': {
            handler(newVal) {
                const { tab } = newVal;
                const list = ['mobileDownload', 'mobileUserCenter'];
                if (list.every((name) => name !== this.$route.name)) {
                    if (tab !== undefined && tab !== '') {
                        this.activeMenu(this.$route.path + '?tab=' + tab);
                    }
                }
            },
            immediate: true
        }
    },
    created() {
        this.activeMenu(this.$route.fullPath);
    },
    methods: {
        async activeMenu(id) {
            await this.$nextTick();
            this.$refs.menu.activeIndex = id.toString();
        },

        onSelect(index) {
            this.$emit('change', index.toString());
        }
    },

    render(createElement, context) {
        const createMemu = (menuList, level) => {
            const menus = [];

            if (!menuList) return menus;

            menuList.forEach((menu) => {
                const { isLeaf } = menu;
                const compName = isLeaf ? 'isc-menu-item' : 'isc-submenu';

                menus.push(
                    createElement(
                        compName,
                        {
                            class: {
                                [`${compName}--${level}`]: true
                            },
                            props: {
                                index: menu.id.toString()
                            }
                        },
                        [
                            createElement(
                                'span',
                                {
                                    staticClass: 'isc-menu-item__title text-truncate',
                                    slot: 'title',
                                    attrs: {
                                        'data-level': level,
                                        style: `--level:${level}`,
                                        title: menu.title
                                    }
                                },
                                menu.title
                            ),
                            ...createMemu(menu.children, level + 1)
                        ]
                    )
                );
            });

            return menus;
        };

        return createElement(
            'isc-menu',
            {
                ref: 'menu',
                class: {
                    'the-menu': true
                },
                props: {
                    textColor: '#333'
                },
                on: {
                    select: this.onSelect
                }
            },
            createMemu(this.menuList, 1)
        );
    }
};
</script>

<style lang="scss" scoped>
.the-menu {
    width: 160px;
    height: auto;
    background: white;
    padding: 0;
    ::v-deep {
        .isc-submenu.is-opened,
        .isc-submenu .isc-menu {
            background: white;
        }

        .isc-menu-item,
        .isc-submenu {
            padding-left: 0;
            font-size: 14px;
        }

        .isc-submenu__title {
            padding: 0;
            font-size: 14px;
        }

        .isc-submenu.is-active .isc-submenu__title i {
            color: rgba(0, 0, 0, 0.8);
        }

        .isc-menu-item.is-active {
            background: #fff;
            background: linear-gradient(to right, rgba(4, 122, 255) 1%, rgba(4, 122, 255, 0.1) 1%);
            font-weight: 600;
            color: #047aff;
        }

        .isc-menu-item .is-dot::after {
            background: #333;
        }

        .isc-menu-item__title {
            margin-left: calc(15px + 20px * var(--level));
            width: calc(100% - 15px - 20px * var(--level));
            display: inline-block;
        }
    }
}
</style>
